import styled from 'styled-components';

import { Link } from '@xing-com/crate-components-link';
import { scale000, spaceL, spaceXS, spaceXXS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const StyledLink = styled(Link)<{ isFirstLink?: boolean }>`
  width: fit-content;
  display: flex;
  margin-bottom: ${spaceXXS};
  margin-top: ${(props) => props.isFirstLink && `${spaceL}`};
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin: ${scale000} ${spaceXS} ${scale000} ${scale000};
`;

export const Styled = {
  Link: StyledLink,
  BodyCopy: StyledBodyCopy,
};
